import { cloneDeep as e, cloneDeep as t, get as n, isArray as r, isArray as i, isPlainObject as a, isPlainObject as o, merge as s, omit as c, omitBy as ee, unionBy as l } from "lodash-es";
import { StructError as te, any as u, array as d, assert as ne, assign as f, boolean as p, define as re, dynamic as m, enums as h, func as g, literal as _, number as ie, object as v, omit as ae, optional as y, record as b, string as x, union as S, validate as oe } from "superstruct";
import { htmlTagNames as se } from "html-tag-names";
import ce from "mitt";
//#region src/types/base.ts
var le = se, ue = /* @__PURE__ */ function(e) {
	return e.STRING_SETTER = "StringSetter", e.BOOLEAN_SETTER = "BooleanSetter", e.JSON_SETTER = "JSONSetter", e.SELECT_SETTER = "SelectSetter", e.NUMBER_SETTER = "NumberSetter", e.EXPRESSION_SETTER = "ExpressionSetter", e.FUNCTION_SETTER = "FunctionSetter", e.COMPONENT_SETTER = "ComponentSetter", e.TEXT_AREA_SETTER = "TextAreaSetter", e.COLOR_SETTER = "ColorSetter", e.ANTD_COLOR_SETTER = "AntDColorSetter", e.RADIO_CROUP_SETTER = "RadioGroupSetter", e.ACTION_FLOW_SETTER = "ActionFlowSetter", e.EMPTY_VALUE_SETTER = "EmptyValueSetter", e;
}({}), de = /* @__PURE__ */ function(e) {
	return e.SHAPE_SETTER = "ShapeSetter", e.ARRAY_SETTER = "ArraySetter", e;
}({}), C = v({
	package: x(),
	version: x(),
	name: x(),
	exportName: y(x()),
	destructuring: y(p()),
	subName: y(x()),
	main: y(x()),
	cssPaths: y(d(x()))
}), fe = d(C), pe = [
	"CBlock",
	"CContainer",
	"CImage",
	"CCanvas",
	"CVideo",
	"CAudio",
	"CText",
	"CNativeTag"
], me = "__DEV_CONFIG__", w = /* @__PURE__ */ function(e) {
	return e.SLOT = "SLOT", e.FUNCTION = "FUNCTION", e.EXPRESSION = "EXPRESSION", e.ACTION = "ACTION", e.EVENT = "EVENT", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.DESIGN = "design", e.SAVE = "save", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.FUNC = "FUNC", e.COMP = "COMP", e;
}({}), he = /* @__PURE__ */ function(e) {
	return e.JUMP_LINK = "JUMP_LINK", e.RUN_CODE = "RUN_CODE", e.REQUEST_API = "REQUEST_API", e.CALL_NODE_METHOD = "CALL_NODE_METHOD", e.ASSIGN_VALUE = "ASSIGN_VALUE", e;
}({}), ge = /* @__PURE__ */ function(e) {
	return e.MEMORY = "MEMORY", e.STATE = "STATE", e;
}({}), D = S([
	x(),
	ie(),
	p(),
	v({
		type: _(w.SLOT),
		renderType: h([E.FUNC, E.COMP]),
		params: y(d(x())),
		value: m(() => S([O, d(O)]))
	}),
	v({
		type: _(w.EXPRESSION),
		value: x()
	}),
	v({
		type: _(w.FUNCTION),
		value: x()
	}),
	v({
		type: _(w.ACTION),
		handler: u()
	}),
	re("normalObj", (e) => !o(e) || [
		w.SLOT,
		w.EXPRESSION,
		w.FUNCTION
	].includes(e?.type) ? !1 : (oe(e, b(x(), D)), !0)),
	d(m(() => D))
]), _e = ["configure"], ve = /* @__PURE__ */ function(e) {
	return e.COMPONENTS = "COMPONENTS", e;
}({}), ye = v({
	type: _(w.EXPRESSION),
	value: x()
}), O = v({
	id: y(x()),
	title: y(x()),
	componentName: x(),
	props: y(b(x(), D)),
	nodeName: y(x()),
	state: y(b(x(), u())),
	children: m(() => y(d(S([x(), O])))),
	eventListener: y(d(u())),
	configure: y(u()),
	css: y(u()),
	style: y(u()),
	classNames: y(d(u())),
	refId: y(x()),
	extra: y(b(u(), u())),
	condition: y(S([p(), ye])),
	loop: y(v({
		open: p(),
		data: S([d(u()), ye]),
		args: y(d(x())),
		forName: y(x()),
		forIndex: y(x()),
		key: y(u()),
		name: y(x())
	})),
	injectEnvList: y(d(u())),
	methods: y(d(u()))
}), be = /* @__PURE__ */ function(e) {
	return e.STRING = "string", e.NUMBER = "number", e.BOOLEAN = "boolean", e.OBJECT = "object", e.ARRAY = "array", e;
}({}), xe = /* @__PURE__ */ function(e) {
	return e.SHAPE = "shape", e.ENUMS = "enums", e.UNION = "union", e;
}({}), Se = /* @__PURE__ */ function(e) {
	return e.COMPONENT = "component", e.EXPRESSION = "expression", e.FUNCTION = "function", e;
}({}), Ce = (e) => a(e) ? e.label : e, we = (e) => a(e) ? e.tip : "", k = S([x(), v({
	label: x(),
	tip: y(x())
})]), Te = v({
	type: _("shape"),
	value: d(v({
		name: x(),
		title: k,
		valueType: m(() => A)
	}))
}), Ee = v({
	type: _("enums"),
	value: d(x())
}), De = v({
	type: _("array"),
	value: m(() => A)
}), Oe = v({
	type: _("array"),
	value: m(() => d(A))
}), A = S([
	h([
		"array",
		"boolean",
		"number",
		"object",
		"string"
	]),
	h([
		"component",
		"expression",
		"function"
	]),
	Te,
	Ee,
	Oe
]), ke = S([x(), v({
	componentName: x(),
	props: y(u()),
	initialValue: y(u()),
	component: y(u()),
	hiddenLabel: y(p())
})]), j = v({
	name: x(),
	title: k,
	valueType: A,
	description: y(x()),
	defaultValue: u(),
	setters: y(d(ke)),
	readOnly: y(p()),
	condition: y(g())
}), Ae = S([x(), g()]), M = /* @__PURE__ */ function(e) {
	return e.SINGLE = "single", e.GROUP = "group", e;
}({}), je = (e) => !!(e.type && ["group", "single"].includes(e.type)), Me = S([x(), v({
	event: x(),
	name: y(x()),
	describe: y(x()),
	params: y(d(v({
		name: x(),
		description: x(),
		example: x()
	}))),
	template: y(x())
})]), Ne = v({
	id: y(x()),
	title: x(),
	snapshot: S([x(), u()]),
	snapshotText: y(x()),
	description: y(x()),
	tags: y(d(x())),
	groupName: y(x()),
	category: y(x()),
	schema: f(ae(O, ["id"]), v({ componentName: y(x()) }))
}), Pe = v({
	componentName: x(),
	title: x(),
	screenshot: y(x()),
	icon: y(x()),
	tags: y(d(x())),
	groupName: y(x()),
	category: y(x()),
	priority: y(ie()),
	npm: y(C),
	snippets: d(Ne),
	props: d(S([
		j,
		v({
			title: y(k),
			type: _("single"),
			content: j
		}),
		v({
			title: y(k),
			type: _("group"),
			content: d(j)
		})
	])),
	events: y(u()),
	methods: y(u()),
	fixedProps: y(u()),
	isContainer: y(S([p(), v({
		placeholder: x(),
		width: x(),
		height: x()
	})])),
	disableEditorDragDom: y(u()),
	enableNodeSizeChange: y(S([p(), g()])),
	isLayout: y(p()),
	rootSelector: y(x()),
	advanceCustom: y(u()),
	extra: y(b(u(), u()))
}), Fe = (e) => ({ data: t, message: n, throwError: r }) => {
	let i = e({
		data: t,
		message: n,
		throwError: r
	});
	if (i.isValidate) return i;
	if (r) throw i.message || n ? Error(`${i.message || n}\n originData: ${JSON.stringify(t)}`) : Error(`${JSON.stringify(t)} \n data struct format is invalidate`);
	return i.message || n ? console.warn(`${i.message || n}\n originData: ${JSON.stringify(t)}`) : console.warn(`${JSON.stringify(t)} \n data struct format is invalidate`), i;
}, N = (e) => {
	let { data: t, message: n, throwError: r, dataStruct: i } = e;
	return Fe(({ data: e }) => {
		try {
			return ne(e, i), { isValidate: !0 };
		} catch (e) {
			let t = e;
			return e instanceof te && (t = e.failures().map((e) => `【${e.path.join(".")}】: ${e.message}\n`)), {
				isValidate: !1,
				message: t,
				error: e
			};
		}
	})({
		data: t,
		message: n,
		throwError: r
	});
}, P = /* @__PURE__ */ function(e) {
	return e.ROOT_CONTAINER = "RootContainer", e;
}({}), Ie = v({
	type: _(w.FUNCTION),
	value: x()
}), F = f(ae(O, ["componentName"]), v({ componentName: _("RootContainer") })), I = ce(), Le = (e, t) => {
	let n = {
		...e,
		value: []
	}, r = e.value, a = new Q([]);
	return t && (a = t.materialsMode || new Q([])), r && (i(r) ? n.value = r.map((e) => new H(e, {
		parent: t,
		materials: a
	})) : o(r) && n.value.push(new H(r, {
		parent: t,
		materials: a
	}))), n;
}, L = class {
	nodeType = "SLOT";
	rawData;
	parent;
	emitter = I;
	data;
	id;
	materialsMode;
	constructor(e, t) {
		this.parent = t?.parent || null, this.rawData = e;
		let n = t?.materials || new Q([]);
		this.materialsMode = n, this.id = G(), this.data = Le(e, this);
	}
	get value() {
		return this.data;
	}
	export(e) {
		let t = this.data, n = (t) => {
			if (t instanceof H) return t.export(e);
			if (o(t)) {
				let e = {};
				return Object.keys(t || {}).forEach((r) => {
					e[r] = n(t[r]);
				}), e;
			}
			return i(t) ? t.map((e) => n(e)) : (e === "design" && delete t.id, t);
		};
		return n(t);
	}
}, Re = (e) => {
	let t = [];
	return e.forEach((e) => {
		let n = e;
		n.type ? n.type === M.SINGLE ? t.push(n.content) : n.type === M.GROUP && (t = [...t, ...Re(n.content)]) : t.push(e);
	}), t;
}, R = (e, t, n) => {
	if (e.type) return e.type === w.SLOT ? new L(e, {
		parent: t,
		materials: n
	}) : e;
	if (o(e)) {
		let r = {};
		return Object.keys(e).forEach((i) => {
			r[i] = z(e[i], t, n);
		}), r;
	}
	return Array.isArray(e) ? e.map((e) => R(e, t, n)) : e;
}, z = (e, t, n) => o(e) ? R(e, t, n) : i(e) ? e.map((e) => R(e, t, n)) : e, B = class e {
	nodeType = "PROP";
	rawData;
	parent;
	emitter = I;
	data;
	name;
	materialsMode;
	constructor(e, t, n) {
		let r = n?.materials || new Q([]);
		this.materialsMode = r, this.parent = n?.parent, this.rawData = t, this.name = e, this.data = z(t, this, r);
	}
	isIncludeSlot() {
		return !1;
	}
	isIncludeExpression() {
		return !1;
	}
	get value() {
		return this.data;
	}
	updateValue(e) {
		let t = this.data;
		this.data = z(e ?? t, this, this.materialsMode), this.emitter.emit("onPropChange", {
			value: this.data,
			preValue: t,
			node: this
		}), this.parent && !(this.parent instanceof L) && this.emitter.emit("onNodeChange", {
			value: this.parent.value,
			preValue: this.parent.value,
			node: this.parent
		});
	}
	get material() {
		let e = this.parent;
		if (e instanceof H) {
			let t = e.material;
			return Re(t?.value.props || []).find((e) => e.name === this.name);
		}
		return null;
	}
	export(t) {
		let n = this.data, r = (n) => {
			if (n instanceof e || n instanceof L || n instanceof H) return n.export(t);
			if (i(n)) return n.map((e) => r(e));
			if (o(n)) {
				let e = {};
				return Object.keys(n || {}).forEach((t) => {
					e[t] = r(n[t]);
				}), e;
			}
			return n;
		};
		return r(n);
	}
}, ze = (e, t = null) => {
	let n = {}, r = Object.keys(e || {});
	return r.length && r.forEach((r) => {
		n[r] = new B(r, e[r], { parent: t });
	}), n;
}, Be = (e) => {
	if (typeof e == "string") return !0;
	N({
		data: e,
		dataStruct: O,
		throwError: !1
	});
}, V = (e, t, n) => {
	if (typeof e == "string") return e;
	let r = {
		...e,
		id: e.id ?? G(),
		children: [],
		props: {},
		methods: e.methods || [],
		configure: s(e.configure || {}, {
			propsSetter: {},
			advanceSetter: {}
		})
	}, i = Object.keys(e.props || {});
	return i.length && i.forEach((i) => {
		let a = e.props?.[i];
		if (a instanceof B) {
			r.props[i] = a;
			return;
		}
		r.props[i] = new B(i, a, {
			parent: t,
			materials: n
		});
	}), e.children && (Array.isArray(e.children) ? r.children = e.children.map((e) => e instanceof H ? e : a(e) ? new H(e, {
		parent: t,
		materials: n
	}) : e) : (e.children instanceof H && (r.children = [e.children]), r.children = [new H(e.children, {
		parent: t,
		materials: n
	})])), r;
}, H = class e {
	nodeType = "NODE";
	rawData;
	data;
	emitter = I;
	parent;
	materialsModel;
	listenerHandler;
	onChangeCbQueue;
	constructor(e, t) {
		this.rawData = JSON.parse(JSON.stringify(e)), Be(e);
		let n = t?.materials || new Q([]);
		this.parent = t?.parent || null, this.materialsModel = n, this.data = V(e, this, n), this.listenerHandler = [], this.onChangeCbQueue = [], this.registerListener();
	}
	registerListener() {
		let e = (e) => {
			let { node: t } = e;
			t === this && t.id === this.id && this.onChangeCbQueue.forEach((t) => t(e));
		};
		this.emitter.on("onNodeChange", e), this.listenerHandler.push(() => {
			this.emitter.off("onNodeChange", e);
		});
	}
	onChange(e) {
		return this.onChangeCbQueue.push(e), () => {
			this.onChangeCbQueue = this.onChangeCbQueue.filter((t) => t !== e);
		};
	}
	destroy() {
		this.listenerHandler.forEach((e) => e());
	}
	get id() {
		return this.data.id;
	}
	get value() {
		return this.data;
	}
	clone(t) {
		let n = {
			...this.export("design"),
			id: t || G()
		};
		return new e(n, { materials: this.materialsModel });
	}
	updateWithPlainObj(e) {
		let t = {
			...this.data,
			...e
		};
		return this.data = V(t, this, this.materialsModel), t;
	}
	updateValue(e) {
		let t = this.data, n = this.updateWithPlainObj(e);
		this.emitter.emit("onNodeChange", {
			value: n,
			preValue: t,
			node: this
		});
	}
	contains(e) {
		return J(this, e);
	}
	get props() {
		return this.data.props;
	}
	get material() {
		return this.materialsModel?.findByComponentName(this.data.componentName);
	}
	getPlainProps() {
		let e = this.data, t = {};
		return Object.keys(e.props || {}).forEach((n) => {
			t[n] = e.props[n].export("design");
		}), t;
	}
	getMaterialConfig(e) {
		return this.data.configure[e] === void 0 ? this.material?.value.isContainer : this.data.configure.isContainer;
	}
	isContainer() {
		return this.getMaterialConfig("isContainer");
	}
	export(t) {
		let r = this.data;
		if (typeof r == "string") return r;
		let i = {};
		Object.keys(r.props || {}).forEach((e) => {
			i[e] = r.props[e].export(t);
		});
		let a = r.children?.map((n) => n instanceof e ? n.export(t) : n), o = r.configure || {}, s = o.propsSetter || {}, c = {};
		Object.keys(s).forEach((e) => {
			let t = n(s, e, !1);
			t && (c[e] = t);
		}), o.propsSetter = c;
		let ee = this.materialsModel.usedMaterials.find((e) => e.componentName === this.material?.componentName);
		this.material && !ee && this.materialsModel.usedMaterials.push(this.material);
		let l = {
			...r,
			configure: o,
			props: i,
			children: a,
			condition: r.condition,
			extra: this.data.extra
		};
		return t === "design" && delete l.id, l = q(l), l;
	}
}, Ve = (e) => (N({
	data: e,
	dataStruct: F,
	throwError: !1
}), e), U = (e, t, n) => {
	let r = {
		...e,
		id: G(),
		props: {},
		componentName: P.ROOT_CONTAINER,
		children: [],
		methods: e.methods || [],
		configure: s(e.configure || {}, {
			propsSetter: {},
			advanceSetter: {}
		}),
		injectEnvList: e.injectEnvList
	}, a = [];
	i(e.children) ? a = e.children.map((e) => e instanceof H ? e : o(e) ? new H(e, {
		parent: t,
		materials: n
	}) : e) : e.children instanceof H ? a.push(e.children) : e.children && o(e.children) && a.push(new H(e.children, {
		parent: t,
		materials: n
	}));
	let c = Object.keys(e.props || {});
	return c.length && c.forEach((i) => {
		let a = e.props?.[i];
		a instanceof B ? r.props[i] = a : r.props[i] = new B(i, a || "", {
			parent: t,
			materials: n
		});
	}), r.children = a, r;
}, W = class e {
	rawData;
	data;
	nodeType = P.ROOT_CONTAINER;
	emitter = I;
	materialsModel;
	listenerHandler;
	onChangeCbQueue;
	parent;
	constructor(e, { parent: t, materials: n }) {
		this.materialsModel = n, this.rawData = JSON.parse(JSON.stringify(e)), this.data = U(e, this, n), this.listenerHandler = [], this.onChangeCbQueue = [], this.registerListener(), this.parent = t;
	}
	registerListener() {
		let e = (e) => {
			let { node: t } = e;
			t === this && t.id === this.id && this.onChangeCbQueue.forEach((t) => t(e));
		};
		this.emitter.on("onNodeChange", e), this.listenerHandler.push(() => {
			this.emitter.off("onNodeChange", e);
		});
	}
	onChange(e) {
		return this.onChangeCbQueue.push(e), () => {
			this.onChangeCbQueue = this.onChangeCbQueue.filter((t) => t !== e);
		};
	}
	get id() {
		return this.data.id;
	}
	get value() {
		return this.data;
	}
	get props() {
		return this.data.props;
	}
	get material() {
		return this.materialsModel?.findByComponentName(this.data.componentName);
	}
	updateWithPlainObj(e) {
		let t = {
			...this.data,
			...e
		};
		return this.data = U(t, this, this.materialsModel), t;
	}
	updateValue(e) {
		let t = this.data;
		this.updateWithPlainObj(e), this.emitter.emit("onNodeChange", {
			value: this.data,
			preValue: t,
			node: this
		});
	}
	contains(e) {
		return J(this, e);
	}
	getMaterialConfig(e) {
		return this.data.configure[e] === void 0 ? this.material?.value.isContainer : this.data.configure.isContainer;
	}
	isContainer() {
		return this.getMaterialConfig("isContainer");
	}
	export(e = T.SAVE) {
		let t = this.data, n = {};
		Object.keys(t.props || {}).forEach((r) => {
			n[r] = t.props[r].export(e);
		});
		let r = t.children?.map((t) => t?.export?.(e)) || [], i = {
			...t,
			props: n,
			children: r.filter((e) => e),
			condition: t.condition,
			extra: this.data.extra
		}, a = c(i, ["id"]);
		return a = q(a), a;
	}
	getPlainProps() {
		let e = this.data, t = {};
		return Object.keys(e.props || {}).forEach((n) => {
			t[n] = e.props[n].export("design");
		}), t;
	}
	destroy() {
		this.listenerHandler.forEach((e) => e());
	}
	clone(t) {
		let n = {
			...this.export("design"),
			id: t || G()
		};
		return new e(n, {
			materials: this.materialsModel,
			parent: null
		});
	}
}, He = (e) => e?.type === w.EXPRESSION, Ue = (e) => e?.type === w.SLOT, We = (e) => e?.type === w.FUNCTION, Ge = (e) => e?.type === w.ACTION, G = () => Math.random().toString(32).slice(3, 9), Ke = (e) => e?.nodeType === "SCHEMA" && e instanceof W, qe = (e) => e?.nodeType === P.ROOT_CONTAINER, Je = (e) => e?.nodeType === "NODE", Ye = (e) => e?.nodeType === "PROP", K = (e) => e?.nodeType === "SLOT", q = (e) => ee(e, (e) => a(e) ? !Object.keys(e).length : r(e) ? !e.length : e == null);
function Xe(e, t) {
	let n = [e];
	for (; n.length;) {
		let e = n.shift();
		if (e && t(e)) return e;
		let i = e?.props || {}, o = (e) => {
			if (e instanceof H) {
				n.push(e);
				return;
			}
			if (e instanceof L && o(e.value.value), e instanceof B) {
				o(e.value);
				return;
			}
			if (a(e)) {
				let t = e;
				Object.keys(t).forEach((e) => {
					o(t[e]);
				});
				return;
			}
			if (r(e)) {
				e.forEach((e) => {
					o(e);
				});
				return;
			}
		};
		o(i);
		let s = e?.value.children.filter((e) => e instanceof H) || [];
		n.push(...s);
	}
}
function J(e, t) {
	return Xe(e, (e) => e.id === t);
}
function Ze(e) {
	if (e) return K(e) || qe(e) || e.isContainer() ? e : Ze(e.parent);
}
var Qe = (e, t) => {
	let n = e.value.componentsTree;
	Y(n, t);
}, Y = (e, t) => {
	if (r(e)) {
		e.map((e) => {
			Y(e, t);
		});
		return;
	}
	t(e);
	let n = (e, t, i, o) => {
		if (K(e)) {
			if (r(e.value.value)) {
				let t = e.value.value;
				return Y(t, o);
			}
			return Y(e.value.value, o);
		}
		if (a(e)) {
			let r = e;
			Object.keys(r).forEach((e) => {
				n(r[e], e, [...i, t], o);
			});
		}
		Array.isArray(e) && e.forEach((e, r) => {
			n(e, String(r), [...i, t], o);
		});
	}, i = e.props;
	n(i, "", [], t), e.value.children.length && e.value.children.forEach((e) => {
		Je(e) && Y(e, t);
	});
}, $e = (e) => {
	let n = t(e), r = n.snippets;
	return delete n.snippets, n.snippets = r.map((t) => ({
		...n,
		...t,
		id: t.id || `${e.componentName}-${G()}`,
		title: t.title || e.title,
		category: t.category || e.category,
		tags: [...t.tags || [], ...e.tags || []],
		groupName: t.groupName || e.groupName,
		snapshot: t.snapshot || e.icon,
		snapshotText: t.snapshotText,
		schema: {
			...t.schema,
			componentName: t.schema.componentName || e.componentName
		}
	})), n;
}, X = class {
	rawData;
	data;
	constructor(e) {
		this.rawData = e, this.data = $e(e);
	}
	get value() {
		return this.data;
	}
	get rawValue() {
		return this.rawData;
	}
	get componentName() {
		return this.data.componentName;
	}
	get snippets() {
		return this.data.snippets;
	}
	getSnippetById(e) {
		return this.data.snippets.find((t) => t.id === e);
	}
}, Z = (e) => {
	if (!i(e)) throw Error("Materials must be a array");
	return e.map((e) => new X(e));
}, et = (e) => {
	e?.forEach((e) => {
		N({
			data: e,
			dataStruct: Pe,
			throwError: !1
		});
	});
}, Q = class {
	rawData;
	data;
	usedMaterials = [];
	constructor(e) {
		this.rawData = e, et(e), this.data = Z(e);
	}
	addMaterials(e) {
		let t = Z(e), n = [], r = this.data.map((e) => {
			let r = t.findIndex((t) => t.componentName === e.componentName);
			return r >= 0 ? (n.push(r), t[r]) : e;
		}), i = t.filter((e, t) => !n.includes(t));
		this.data = [...r, ...i];
	}
	replaceMaterials(e) {
		let t = Z(e);
		this.data = [...t];
	}
	removeMaterial(e) {
		let t = this.data.filter((t) => !e.includes(t.componentName));
		this.data = t;
	}
	findByComponentName(e) {
		return this.data.find((t) => t.componentName === e);
	}
	findSnippetById(e) {
		let t = [...this.data], n = null;
		for (; !n && t.length;) n = t.pop()?.getSnippetById(e);
		return n;
	}
	getAllSnippets() {
		let e = this.data.reduce((e, t) => (e.push(...t.snippets), e), []), t = [], n = { default: [] };
		e.forEach((e) => {
			let r = e.groupName || "default";
			t.includes(r) || (t.push(r), n[r] = []), n[r].push(e);
		});
		let r = [];
		return t.forEach((e) => {
			let t = ["default"], i = { default: [] }, a = n[e];
			if (a.length !== 0) {
				a.forEach((e) => {
					let n = e.category || "default";
					t.includes(n) || (t.push(n), i[n] = []), i[n].push(e);
				});
				let n = [];
				t.forEach((e) => {
					i[e].length && n.push({
						name: e,
						list: i[e]
					});
				});
				let o = {
					name: e,
					list: n
				};
				r.push(o);
			}
		}), r = r.sort((e, t) => (e.name || "") > (t.name || "") ? 1 : -1), r;
	}
	get value() {
		return this.data;
	}
	get rawValue() {
		return this.rawData;
	}
}, tt = /* @__PURE__ */ function(e) {
	return e.PAGE = "PAGE", e.COMPONENT = "COMPONENT", e;
}({}), nt = v({
	version: y(x()),
	name: y(x()),
	css: y(x()),
	lifecycle: y(u()),
	props: y(u()),
	methods: y(d(Ie)),
	componentsMeta: d(f(v({ componentName: x() }), C)),
	thirdLibs: y(fe),
	componentsTree: F,
	assets: y(d(u())),
	extra: y(u())
}), rt = (e) => (N({
	data: e,
	dataStruct: nt,
	throwError: !1
}), e), $ = (e, t, n) => ({
	...e,
	componentsTree: new W(e.componentsTree, {
		parent: t,
		materials: n
	})
}), it = class t {
	nodeType = "PAGE";
	rawData;
	emitter = I;
	data;
	parent;
	materialsModel;
	assetPackagesList;
	constructor(e, t) {
		rt(e), this.rawData = JSON.parse(JSON.stringify(e)), this.materialsModel = new Q(t?.materials || []), this.data = $(e, this, this.materialsModel), this.assetPackagesList = [...t?.assetPackagesList || [], ...this.data.assets || []];
	}
	updatePage(e) {
		let t = this.data;
		this.rawData = JSON.parse(JSON.stringify(e)), this.data = $(e, this, this.materialsModel), this.emitter.emit("onPageChange", {
			value: this.data,
			preValue: t,
			node: this
		});
	}
	reloadPage(e) {
		let t = this.data;
		e && (this.rawData = JSON.parse(JSON.stringify(e)), this.data = $(e, this, this.materialsModel)), this.emitter.emit("onReloadPage", {
			value: this.data,
			preValue: t,
			node: this
		});
	}
	get value() {
		return this.data;
	}
	getNode(e) {
		if (!e) return;
		let t = this.data.componentsTree;
		return J(t, e);
	}
	addNode(e, n, r = "AFTER") {
		if (r === "AFTER" || r === "BEFORE") {
			let i = n.parent;
			if (i === null && n instanceof W) return console.warn("Not found parent node"), !1;
			if (i instanceof B) return console.warn("CProp can not add node"), !1;
			if (i instanceof L) {
				let t = i.value.value, a = t.findIndex((e) => e === n) ?? -1;
				return a >= 0 && (r === "BEFORE" ? t.splice(a, 0, e) : t.splice(a + 1, 0, e), e.parent = i, i.parent?.updateValue(), !0);
			}
			if (i instanceof t) return !1;
			let a = i?.value.children.findIndex((e) => e === n) ?? -1;
			return a >= 0 ? (r === "BEFORE" ? i?.value.children.splice(a, 0, e) : i?.value.children.splice(a + 1, 0, e), e.parent = i, i?.updateValue(), !0) : (console.warn("Not found target node"), !1);
		}
		if (r === "CHILD_START") return n.value.children.unshift(e), e.parent = n, n.updateValue(), !0;
		if (r === "CHILD_END") return n.value.children.push(e), e.parent = n, n.updateValue(), !0;
		if (a(r)) {
			let t = r;
			if (t.type === "CHILD") {
				let r = t.pos, i = t.index || 0;
				return r === "BEFORE" ? n?.value.children.splice(i, 0, e) : n?.value.children.splice(i + 1, 0, e), e.parent = n, n.updateValue(), !0;
			}
			console.warn("Can not parse pos obj");
		}
		return !1;
	}
	createNode(e) {
		return delete e.id, new H(e, {
			parent: null,
			materials: this.materialsModel
		});
	}
	addNodeById(e, t, n = "AFTER") {
		let r = this.getNode(t);
		return r ? this.addNode(e, r, n) : (console.warn(`Not find a node by ${t}, pls check it`), !1);
	}
	copyNode(e) {
		let t = e.export("design");
		t.id = G();
		let n = new H(t, {
			parent: e.parent,
			materials: this.materialsModel
		});
		return this.addNode(n, e, "AFTER"), n;
	}
	copyNodeById(e) {
		let t = this.getNode(e);
		return t && t instanceof H ? this.copyNode(t) : !1;
	}
	moveNode(e, t, n) {
		this.deleteNode(e);
		let r = t;
		return ["AFTER", "BEFORE"].includes(n) && (r = t.parent), e.parent = r, this.addNode(e, t, n);
	}
	moveNodeById(e, t, n) {
		let r = this.getNode(e), i = this.getNode(t);
		return r && i && r instanceof H && i instanceof H ? this.moveNode(r, i, n) : !1;
	}
	deleteNode(e) {
		let t = e.parent;
		if (!t) throw Error("parent node is null or undefined, pls check it");
		if (t instanceof L) {
			let n = t.value.value, r = n.findIndex((t) => t === e), i = n[r];
			return n.splice(r, 1), t.parent?.updateValue(), i;
		}
		if (t instanceof H || t instanceof W) {
			let n = t.value.children, r = n.findIndex((t) => t === e), i = n[r];
			return n.splice(r, 1), t.updateValue(), i;
		}
	}
	deleteNodeById(e) {
		let t = this.getNode(e);
		if (t) return this.deleteNode(t);
	}
	export(t = T.SAVE) {
		let n = this.data.componentsTree.export(t), r = this.assetPackagesList, i = [], a = this.materialsModel.usedMaterials.map((t) => {
			let n = r.find((e) => e.package === t.value.npm?.package);
			return n && i.push(n), {
				componentName: t.componentName,
				...e(t.value.npm || {})
			};
		}).filter((e) => e.componentName && e.package && e.version ? !0 : (console.warn(`${JSON.stringify(e, null, 2)} not a valid material info`), !1));
		this.materialsModel.usedMaterials = [];
		let o = {
			...this.data,
			componentsTree: q(n),
			componentsMeta: a,
			thirdLibs: this.data.thirdLibs,
			assets: [],
			extra: this.data.extra
		};
		return this.data.thirdLibs?.forEach((e) => {
			let t = r.find((t) => e.package === t.package);
			t && i.push(t);
		}), o.assets = l(i, (e) => e.package), o = c(o, ["id"]), JSON.parse(JSON.stringify(o));
	}
	getRootNode() {
		return this.data.componentsTree;
	}
}, at = {
	version: "1.0.0",
	name: "EmptyPage",
	componentsMeta: [],
	componentsTree: {
		componentName: P.ROOT_CONTAINER,
		props: {},
		children: []
	}
}, ot = [
	{ event: "onClick" },
	{ event: "onDoubleClick" },
	{ event: "onMouseOver" },
	{ event: "onMouseDown" },
	{ event: "onMouseUp" },
	{ event: "onMouseMove" },
	{ event: "onMouseIn" },
	{ event: "onMouseOut" },
	{ event: "onMouseLeave" }
];
//#endregion
export { Ae as ActionTypeDescribe, xe as AdvanceDataType, De as ArrayDataTypeDescribe, ge as AssignValueType, pe as BaseComponentTagList, be as BaseDataType, X as CMaterial, Me as CMaterialEventTypeDescribe, Pe as CMaterialTypeDescribe, Q as CMaterials, H as CNode, O as CNodeDataStructDescribe, w as CNodePropsTypeEnum, it as CPage, nt as CPageDataTypeDescribe, B as CProp, W as CRootNode, F as CRootNodeDataTypeDescribe, L as CSlot, de as ComplexSetterTypeEnum, ot as DEFAULT_EVENT_LIST, me as DEV_CONFIG_KEY, _e as DevKey, ve as ENGEnvEnum, at as EmptyPage, Ee as EnumDataTypeDescribe, T as ExportTypeEnum, Ie as FunctionPropertyTypeDescribe, le as HTMl_TAGS, P as InnerComponentNameEnum, C as LibMetaTypeDescribe, he as LogicType, k as MTitleDescribe, j as MaterialPropDescribe, D as PropsDataStructDescribe, M as PropsUIType, A as PropsValueTypeDescribe, tt as RenderType, ke as SetterTypeDescribe, ue as SetterTypeEnum, Te as ShapeDataTypeDescribe, E as SlotRenderType, Ne as SnippetsTypeDescribe, Se as SpecialDataType, fe as ThirdLibTypeDescribe, Oe as UnionDataTypeDescribe, et as checkMaterials, Be as checkNode, rt as checkPage, Ve as checkRootNode, q as clearSchema, Ze as findContainerNode, Xe as findNode, Ce as getMTitle, we as getMTitleTip, J as getNode, G as getRandomStr, Ge as isAction, He as isExpression, We as isFunction, Ue as isJSSlotPropNode, Je as isNodeModel, qe as isPageModel, Ye as isPropModel, Ke as isSchemaModel, K as isSlotModel, je as isSpecialMaterialPropType, V as parseNode, $ as parsePage, U as parseSchema, ze as transformObjToPropsModelObj, Qe as traversePageNode, Y as traversePageNodeCore };

//# sourceMappingURL=index.es.js.map